// PENDING and APPLYING are client-side; the rest come from `action.result.status`
const aiAssistantProposalStatuses = {
    PENDING: 'PENDING',
    APPLYING: 'APPLYING',
    APPLIED: 'APPLIED',
    REJECTED: 'REJECTED',
    FAILED: 'FAILED',
    EXPIRED: 'EXPIRED',
};

export default aiAssistantProposalStatuses;
